import { Component, OnInit } from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, tap, switchMap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import { of } from 'rxjs/observable/of';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { ReportsHelperService } from '../../../services/tools/reports-helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { ReportesPagosService } from '../../../services/reportes/reportes-pagos.service';
import { SucursalesService } from '../../../services/sucursales.service';

@Component({
    selector: 'app-reporte-pagos-penalizaciones',
    templateUrl: './reporte-pagos-penalizaciones.component.html'
  })

export class ReportePagosPenalizacionesComponent implements OnInit {

    public reportData: any [] = [];
    public totales: any = {};
    public tiposCreditos: any[] = [];
    //Filtros
    public tipoCreditoSelected: any = '';
    public fechaInicio: string = null;
    public fechaFin: string = null;
    public sucursales: any[] = [];
    public sucursal: any = {id:null};
    public sucursalPorDefecto: string = "";

    //Helpers
    public isLoading: boolean = true;
    public isItemsArrayEmpty: boolean = null;

    constructor(
        private helperService: HelpersService,
        private reportesService: ReportesPagosService,
        private sucursalesService : SucursalesService,
        public helper: ReportsHelperService,
        private creditosService: CreditosService
    ){

    }

    public ngOnInit() {
        this.setupDefaultState();
    }

    private setupDefaultState() {
        let defaultDates = this.helper.getDefaultDates();
        this.fechaInicio = defaultDates.fechaInicio;
        this.fechaFin = defaultDates.fechaFin;
        this.getTiposCreditos();
        this.getSucursales();
    }

    private getSucursales(){
        this.isLoading = true;
        this.sucursalesService.get().subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content){
              this.sucursales = jsonResult.content.data;
              if (this.sucursales.length>1){
                this.sucursalPorDefecto = "Seleccione";
              } else if(this.sucursales.length>0){
                this.sucursal =  this.sucursales[0];
              }
              this.isLoading = false;
              this.updateReporte(); 
            }
            
          }, error =>
          {
            // se resuelve error 403 y 500
            this.isLoading = false;
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    sucursalChanged(sucursal){
        if(sucursal){
        this.sucursal = sucursal;
        this.updateReporte();
        }
    }

    private getTiposCreditos(){
        this.creditosService.getTiposCreditos().subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                if(jsonResult.content){
                    this.tiposCreditos = jsonResult.content;
                }
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    private getFiltros(){
        let filters = {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            tipoCredito: this.tipoCreditoSelected,
            sucursal : this.sucursal.id
        }

        return filters;
    }

    public updateReporte(){

        let filters = this.getFiltros();

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.getReportePenalizaciones(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                let items = [];
                let totales = {};

                if(jsonResult.content ){
                    if(jsonResult.content.items){
                        items = jsonResult.content.items;
                    }
                    if(jsonResult.content.totales){
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
                this.isItemsArrayEmpty = this.reportData.length == 0;
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public descargar() {

        let filters = this.getFiltros();

        this.reportesService.exportPenalizacionesToExcel(filters).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/pagos/penalizaciones/reporte-pagos-penalizaciones.component.ts